export default __webpack_public_path__ + "static/media/dress8.d400517e.jpeg";